// extracted by mini-css-extract-plugin
export default {"easel":"easelContainer_easel__03fT-","square":"easelContainer_square__N1ep5"};